import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const BasketSkeleton = () => (
  <div data-testid="skeleton-basket">
    <div className="w-full">
      <Skeleton className="mb-2.5 h-[10rem]" />
      <Skeleton className="mb-2.5 h-[10rem]" />
      <Skeleton className="mb-2.5 h-[10rem]" />
      <Skeleton className="mb-2.5 h-[10rem]" />
      <Skeleton className="mb-2.5 h-[10rem]" />
      <Skeleton className="mb-2.5 h-[10rem]" />
      <Skeleton className="mb-2.5 h-[10rem]" />
    </div>
  </div>
);
